const GPS = {
	PI: 3.14159265358979324,
	x_pi: (3.14159265358979324 * 3000.0) / 180.0,
	delta: function(lat, lon) {
		var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
		var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
		var dLat = this.transformLat(lon - 105.0, lat - 35.0);
		var dLon = this.transformLon(lon - 105.0, lat - 35.0);
		var radLat = (lat / 180.0) * this.PI;
		var magic = Math.sin(radLat);
		magic = 1 - ee * magic * magic;
		var sqrtMagic = Math.sqrt(magic);
		dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * this.PI);
		dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * this.PI);
		return { lat: dLat, lon: dLon };
	},

	//GPS---高德
	gcj_encrypt: function(wgsLat, wgsLon) {
		if (this.outOfChina(wgsLat, wgsLon)) return { lat: wgsLat, lon: wgsLon };

		var d = this.delta(wgsLat, wgsLon);
		return { lat: wgsLat + d.lat, lon: wgsLon + d.lon };
	},
	outOfChina: function(lat, lon) {
		if (lon < 72.004 || lon > 137.8347) return true;
		if (lat < 0.8293 || lat > 55.8271) return true;
		return false;
	},
	transformLat: function(x, y) {
		var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
		ret += ((20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0) / 3.0;
		ret += ((20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin((y / 3.0) * this.PI)) * 2.0) / 3.0;
		ret += ((160.0 * Math.sin((y / 12.0) * this.PI) + 320 * Math.sin((y * this.PI) / 30.0)) * 2.0) / 3.0;
		return ret;
	},
	transformLon: function(x, y) {
		var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
		ret += ((20.0 * Math.sin(6.0 * x * this.PI) + 20.0 * Math.sin(2.0 * x * this.PI)) * 2.0) / 3.0;
		ret += ((20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin((x / 3.0) * this.PI)) * 2.0) / 3.0;
		ret += ((150.0 * Math.sin((x / 12.0) * this.PI) + 300.0 * Math.sin((x / 30.0) * this.PI)) * 2.0) / 3.0;
		return ret;
	},
	/**
	 * 两点之间的距离
	 * @param  {number} latA 起点纬度
	 * @param  {number} lngA 起点经度
	 * @param  {number} latB 终点纬度
	 * @param  {number} lngB 终点经度
	 * @return {number}      返回距离(米)
	 */
	distance: function(latA, lngA, latB, lngB) {
		var earthR = 6371000;
		var x =
			Math.cos((latA * this.PI) / 180) *
			Math.cos((latB * this.PI) / 180) *
			Math.cos(((lngA - lngB) * this.PI) / 180);
		var y = Math.sin((latA * this.PI) / 180) * Math.sin((latB * this.PI) / 180);
		var s = x + y;
		if (s > 1) s = 1;
		if (s < -1) s = -1;
		var alpha = Math.acos(s);
		var distance = alpha * earthR;
		return distance;
	},
};

export default GPS;
